import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/auth";

export default function AdminSubscriptions() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/subscriptions").then((r) => setRows(r.data)); }, []);

  return (
    <div data-testid="admin-subscriptions-page" className="p-8 lg:p-10 max-w-[1400px]">
      <h1 className="font-display font-extrabold text-4xl text-black tracking-tight">Subscriptions</h1>
      <p className="text-black/60 mt-1.5 text-sm">All tenant subscriptions across the platform.</p>

      <div className="mt-7 bg-white rounded-2xl border border-black/8 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#FFFCF2] text-black/55 text-[11px] uppercase tracking-wider">
            <tr>
              <th className="text-left p-4 font-bold">Tenant</th>
              <th className="text-left p-4 font-bold">Subdomain</th>
              <th className="text-left p-4 font-bold">Plan</th>
              <th className="text-left p-4 font-bold">Amount</th>
              <th className="text-left p-4 font-bold">Cycle</th>
              <th className="text-left p-4 font-bold">Status</th>
              <th className="text-left p-4 font-bold">Started</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-black/8">
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-[#FFFCF2]/60">
                <td className="p-4">
                  <Link to={`/admin/tenants/${r.id}`} className="font-semibold text-black hover:text-[#1B4332]">{r.tenant}</Link>
                </td>
                <td className="p-4 font-mono text-xs text-black/70">{r.subdomain}</td>
                <td className="p-4 text-black/70">{r.plan}</td>
                <td className="p-4 tabular-nums">₦{Number(r.amount || 0).toLocaleString()}</td>
                <td className="p-4 text-black/70 capitalize">{r.billing_cycle}</td>
                <td className="p-4">
                  <span className={`text-[10px] font-bold uppercase px-2 py-1 rounded-md ${
                    r.status === "active" ? "bg-[#E8F5E9] text-[#1FA868]" :
                    r.status === "pending" ? "bg-[#FFF5D6] text-amber-700" :
                    "bg-black/5 text-black/60"
                  }`}>{r.status}</span>
                </td>
                <td className="p-4 text-black/60 text-xs">{(r.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="7" className="p-10 text-center text-black/50">No subscriptions.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
